import { getRentalPortalListPage } from '../../../../api'

import { RENTAL_PORTAL_LIST_PERMISSIONS_REQUEST } from './useRentalPortalListPermissions.constants'

// TODO: drop the probe once every list reads the permissions from its own page
export function getRentalPortalListPermissions(resource) {
  return getRentalPortalListPage({
    data: RENTAL_PORTAL_LIST_PERMISSIONS_REQUEST,
    resource,
  })
}
